module.exports = __webpack_public_path__ + "static/media/facebook-logo.4fc31f03.svg";